import Picture1 from './Picture1.png';
import Picture2 from './Picture2.png';
import Picture3 from './Picture3.png';
const images = [
    {
      imgURL: Picture1,
      imgAlt: "img-1",
      imglink: "/training/operational_risk"
    },
    {
      imgURL: Picture2,
      imgAlt: "img-2",
      imglink: "/training/operational_risk"
    },
    {
      imgURL: Picture3,
      imgAlt: "img-3",
      imglink: "/training/operational_risk"
    }
  ];
  
  export default images;